import {Button, Drawer, Field, HStack, Icon, Input, Portal, Spinner, Text, Textarea, VStack} from "@chakra-ui/react";
import {IoCloseSharp} from "react-icons/io5";
import {useState, useEffect} from "react";
import {showToast} from "@/components/ui/toaster";
import ProductLineTypeSelect from "@/components/ui/selects/ProductLineTypeSelect";

const AddAgentDrawer = ({isOpen, onClose, onSave}) => {
    const [isSaving, setIsSaving] = useState(false);
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [type, setType] = useState(null);

    useEffect(() => {
        if (isOpen) {
            setName('');
            setDescription('');
            setType(null);
        }
    }, [isOpen]);

    const handleSave = async () => {
        if (!name.trim() || !type) return;
        setIsSaving(true);
        try {
            await onSave({name: name.trim(), description: description.trim(), type});
            showToast("Agent created", null, "success");
            onClose();
        } catch {
            showToast("Error", "Failed to create agent", "error");
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Drawer.Root open={isOpen} onOpenChange={(e) => !e.open && onClose()} size={'xl'} placement={'end'}>
            <Portal>
                <Drawer.Backdrop/>
                <Drawer.Positioner padding="4">
                    <Drawer.Content minW={'100%'} bg={"bg.drawer"} borderRadius={16}>
                        <Drawer.Header>
                            <HStack justifyContent={'space-between'} w={'full'}>
                                <Text color={'white'}>Add Agent</Text>
                                <Icon fontSize={32} color={'text.grey'} onClick={onClose} cursor={'pointer'}>
                                    <IoCloseSharp/>
                                </Icon>
                            </HStack>
                        </Drawer.Header>
                        <Drawer.Body>
                            <VStack w={{sm: 'full', xl: '50%'}} alignItems={'flex-start'} mx={'auto'}>
                                <Field.Root required>
                                    <Field.Label color={'white'} fontSize={18}>
                                        Agent name <Field.RequiredIndicator/>
                                    </Field.Label>
                                    <Input variant={'primary'} placeholder="Enter agent name" value={name} onChange={(e) => setName(e.target.value)}/>
                                </Field.Root>

                                <ProductLineTypeSelect value={type} onChange={setType} />

                                <Field.Root mt={4}>
                                    <Field.Label color={'white'} fontSize={18}>Description</Field.Label>
                                    <Textarea
                                        variant={'outline'}
                                        placeholder="Enter agent description"
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value.slice(0, 200))}
                                        maxLength={200}
                                        resize={'none'}
                                        rows={4}
                                        color={'white'}
                                    />
                                    <Field.HelperText>{description.length}/200</Field.HelperText>
                                </Field.Root>
                            </VStack>
                        </Drawer.Body>
                        <Drawer.Footer borderRadius={16}>
                            <HStack justifyContent={'flex-end'} w={'full'} gap={3}>
                                <Button variant="outlined" textDecoration='unset' onClick={onClose} disabled={isSaving}>Cancel</Button>
                                <Button variant="primary" textDecoration='unset' onClick={handleSave} disabled={isSaving || !name.trim() || !type}>
                                    {isSaving ? <Spinner size="sm"/> : "Save"}
                                </Button>
                            </HStack>
                        </Drawer.Footer>
                    </Drawer.Content>
                </Drawer.Positioner>
            </Portal>
        </Drawer.Root>
    );
};

export default AddAgentDrawer;
